import React, { useEffect, useMemo, useState } from "react";
import styles from "../styles/tickets.module.css";
import Layout from "../components/Layout/Layout";
import { API_Path } from "../const";
import { GetTokenApi } from "../api/api-service";
import { toast } from "react-toastify";
import Loading from "../components/loader/Loading";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router";
import Table from "react-bootstrap/esm/Table";
import NoDataFoundImg from "../components/nodatafound/NoDataFoundImg";
// import XLSX from 'xlsx'; // Import XLSX library for Excel manipulation
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import { exportTableToPDF } from "../components/common/CommonFun";
import usePageTitle from "../components/customHook/usePageTitle";
import PDFIcon from "../assets/images/file-pdf.svg";
import excelIcon from "../assets/images/microsoft_excel.svg";

export default function Tickets() {
    usePageTitle("Tickets", true);
    const navigate = useNavigate();
    const [query, setQuery] = useState("");
    const [searchResults, setSearchResults] = useState([]);
    const [ticketsData, setTicketsData] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        GetUserAllSupports();
        setSearchResults(ticketsData);
        // exportTableToExcel("tblData");
    }, []);

    const GetUserAllSupports = () => {
        const GetCurrentUserAllTickets = new Promise((resolve) => {
            resolve(GetTokenApi(API_Path.GetCurrentUserAllSupports));
        });
        GetCurrentUserAllTickets.then((res) => {
            if (res.data) {
                setTicketsData(res.data);
                setSearchResults(res.data);
            } else {
                toast.error("Something went wrong!");
            }
            setLoading(false);
        });
    };

    const handleInputChange = (event) => {
        const newQuery = event.target.value;
        setQuery(newQuery);
        const filteredData = ticketsData.filter((item) => item.TICKETNO.includes(newQuery.toLowerCase()) || item.TICKETNO.toString().includes(newQuery.toString()));
        setSearchResults(filteredData);
    };

    const clickHandler = (data) => {
        let result = data.TICKETNO.split("#", 2);
        navigate(`/tickets-detail/${result[1]}`, {
            state: {
                id: result[1],
                name: data.SUBJECT,
            },
        });
    };

    const columns = useMemo(() => [
        { name: "Status", selector: (row) => row.STATUS, sortable: true, cell: (row) => <div className={row.STATUS === "OPEN" ? "green_color" : "red_color"}>{row.STATUS}</div> },
        {
            name: "Title",
            selector: (row) => row.SUBJECT,
            sortable: true,
            cell: (row) => (
                <button type="button" className="btn_table" onClick={() => clickHandler(row)}>
                    {row.SUBJECT}
                </button>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
        },
        {
            name: "Ticket No.",
            selector: (row) => row.TICKETNO,
            sortable: true,
            cell: (row) => (
                <button type="button" className="btn_table" onClick={() => clickHandler(row)}>
                    {row.TICKETNO}
                </button>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
        },
        { name: "Total Messages", selector: (row) => row.TOTAL_MESSAGE, sortable: true },
        { name: "Date", selector: (row) => row.ENTRYDATE, sortable: true },
    ]);

    const handlePrint = () => {
        const newTab = window.open("", "_blank");
        let tableContent = "<h2>Supports</h2><table style='width: 100%;'><thead style='text-align: left'><tr>";
        columns.forEach((column) => (tableContent += `<th>${column.name}</th>`));

        tableContent += "</tr></thead><tbody>";
        searchResults.forEach((result) => {
            tableContent += "<tr>";
            columns.forEach((column) => (tableContent += `<td>${column.selector(result)}</td>`));
            tableContent += "</tr>";
        });

        tableContent += "</tbody></table>";
        newTab.document.write(tableContent);
        newTab.document.close();
        newTab.print();
    };

    function exportTableToExcel() {
        const worksheet = XLSX.utils.json_to_sheet(searchResults);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        const blob = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8" });
        saveAs(blob, "exportedData.xlsx");
    }

    return (
        <Layout>
            {loading && <Loading />}
            <section>
                <div className={styles.section}>
                    <div className={styles.section_head}>
                        <div className="container">
                            <div className="row align-items-center">
                                <div className="col-lg-6 col-md-12 col-sm-12">
                                    <div className="title_heading d-flex p-0">
                                        {/* <p>Home /</p> */}
                                        <h4>Tickets</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={styles.section_body}>
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6 col-md-12 col-sm-12">
                                    <div className={styles.section_flex}>
                                        <ul>
                                            <li className={`${styles.section_icon} ms-0`}>
                                                <button
                                                    type="button"
                                                    className={styles.btn_dt}
                                                    onClick={() => exportTableToPDF(ticketsData, columns, "support.pdf", "Support")}
                                                    disabled={searchResults == 0}
                                                >
                                                     <img src={PDFIcon} alt="" />
                                                </button>
                                            </li>
                                            <li className={styles.section_icon}>
                                                <button type="button" className={styles.btn_dt} onClick={() => exportTableToExcel("tblData")} disabled={searchResults == 0}>
                                                <img src={excelIcon} alt="" />
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-12 col-sm-12 text-end">
                                    <div className={styles.section_searchbar}>
                                        <div className="searchbar_style">
                                            <input type="search" placeholder="Search" className="form-control" value={query} onChange={(e) => handleInputChange(e)}  maxLength={40}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="data_table_body">
                                {searchResults.length > 0 ? (
                                    <DataTable columns={columns} data={searchResults} pagination id="tblData" />
                                ) : (
                                    <Table striped bordered hover>
                                        <thead>
                                            <tr className="border-1">
                                                <th className="border-0">Status</th>
                                                <th className="border-0">Title</th>
                                                <th className="border-0">Ticket No</th>
                                                <th className="border-0">Total Messages</th>
                                                <th className="border-0">Date</th>
                                            </tr>
                                        </thead>
                                        <NoDataFoundImg />
                                    </Table>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </Layout>
    );
}
